import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Button from "@atlaskit/button/new";
import ConfirmModal from "../common/components/ConfirmModal";
import { restoreBackup } from "../redux/actions/backupRestoreActions";
const RestoreFlow = ({ backupFileRef, filename }) => {
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);

  const onConfirm = () => {
    dispatch(restoreBackup(backupFileRef));
    setOpen(false);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} appearance="link">
        Restore
      </Button>

      <ConfirmModal
        action={"restore backup"}
        additionalDescription={
          <p>
            <b>Note:</b>
            This will <b>overwrite</b> current flow with the backup!
          </p>
        }
        targetName={filename || ""}
        targetId={backupFileRef}
        isOpen={isOpen}
        onAction={onConfirm}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default RestoreFlow;
